import { PushNotifications } from "@capacitor/push-notifications";
import { isNative } from "./platform";
import { registerPushDevice } from "@/features/notifications/api/push-api";

/**
 * Typed adapter for push notifications on native builds.
 * No-ops on web.
 */
export async function initPushNotifications(): Promise<void> {
  if (!isNative) {
    return;
  }

  try {
    const perm = await PushNotifications.requestPermissions();
    if (perm.receive !== "granted") {
      return;
    }

    await PushNotifications.addListener("registration", (token) => {
      if (token.value) {
        void registerPushDevice(token.value);
      }
    });

    await PushNotifications.addListener("registrationError", () => {
      // Non-fatal for beta
    });

    await PushNotifications.register();
  } catch {
    // Native runtime missing push capability
  }
}
